import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  type: "button",
  disabled: ""
}
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xxl-4 col-xm-12" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "col-md-8 col-sm-12 col-lg-8 col-xl-8 col-xxl-8 col-xm-12" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = {
  class: "accordion mb-4",
  id: "statisticsAccordion"
}
const _hoisted_16 = { class: "accordion-item" }
const _hoisted_17 = {
  class: "accordion-header",
  id: "statisticsHeader"
}
const _hoisted_18 = {
  id: "statisticsCollapse",
  class: "accordion-collapse collapse",
  "aria-labelledby": "statisticsHeader",
  "data-bs-parent": "#statisticsAccordion"
}
const _hoisted_19 = {
  class: "accordion-body",
  id: "statisticsContent"
}
const _hoisted_20 = { class: "row mt-4" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { class: "card" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = { class: "row text-center" }
const _hoisted_25 = { class: "col-md-2 col-6 mb-3" }
const _hoisted_26 = { class: "border-end" }
const _hoisted_27 = { class: "text-success mb-1" }
const _hoisted_28 = { class: "col-md-2 col-6 mb-3" }
const _hoisted_29 = { class: "text-danger mb-1" }
const _hoisted_30 = { class: "col-md-2 col-6 mb-3" }
const _hoisted_31 = { class: "text-info mb-1" }
const _hoisted_32 = { class: "col-md-2 col-6 mb-3" }
const _hoisted_33 = { class: "text-warning mb-1" }
const _hoisted_34 = { class: "col-md-2 col-6 mb-3" }
const _hoisted_35 = { class: "text-primary mb-1" }
const _hoisted_36 = { class: "col-md-2 col-6 mb-3" }
const _hoisted_37 = { class: "text-secondary mb-1" }
const _hoisted_38 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_39 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_40 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_41 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_42 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["src"]
const _hoisted_45 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center bg-light rounded-circle border border-2 border-light user-placeholder",
  style: {"width":"50px","height":"50px"}
}
const _hoisted_46 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_47 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_48 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_49 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_50 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_51 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_52 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_53 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_54 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_55 = { class: "shadow-none lh-1 fw-medium text-end pe-0 sm" }
const _hoisted_56 = { class: "dropdown" }
const _hoisted_57 = { class: "dropdown-menu" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_60 = {
  class: "modal fade",
  id: "imageModal",
  tabindex: "-1",
  "aria-labelledby": "imageModalLabel",
  "aria-hidden": "true",
  ref: "modalEl"
}
const _hoisted_61 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_62 = { class: "modal-content" }
const _hoisted_63 = {
  class: "modal-body d-flex justify-content-center align-items-center",
  style: {"min-height":"300px"}
}
const _hoisted_64 = ["src"]
const _hoisted_65 = {
  class: "modal fade",
  id: "voirImageModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "voirImageModal"
}
const _hoisted_66 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_67 = { class: "modal-content" }
const _hoisted_68 = {
  class: "modal-body d-flex justify-content-center align-items-center",
  style: {"min-height":"400px"}
}
const _hoisted_69 = {
  key: 0,
  class: "text-center"
}
const _hoisted_70 = ["src"]
const _hoisted_71 = {
  key: 1,
  class: "text-center text-muted"
}
const _hoisted_72 = { class: "modal-footer" }
const _hoisted_73 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.valideEtape3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.telecharger && _ctx.telecharger(...args))),
                disabled: _ctx.isLoading,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                type: "button"
              }, [
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "flaticon-download position-relative ms-5 fs-12" }, null, -1)),
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Exporter"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("span", {
                        class: "spinner-grow spinner-grow-sm me-2",
                        role: "status",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode(" Export en cours... ", -1)
                    ]))]))
              ], 8, _hoisted_4))
            : _createCommentVNode("", true),
          (!_ctx.valideEtape3)
            ? (_openBlock(), _createElementBlock("button", _hoisted_7, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("span", {
                  class: "spinner-grow spinner-grow-sm",
                  role: "status",
                  "aria-hidden": "true"
                }, null, -1),
                _createElementVNode("span", { class: "visually-hidden" }, "Chargement...", -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot clé ", -1)),
                _createVNode(_component_Field, {
                  modelValue: _ctx.motCle,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.motCle) = $event)),
                  name: "mot",
                  type: "text",
                  "aria-disabled": "true",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Recherche par mot clé"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "mot",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Etats ", -1)),
                _createVNode(_component_Field, {
                  name: "etat",
                  modelValue: _ctx.etat,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.etat) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      mode: "tags",
                      options: _ctx.etatsOptions,
                      searchable: true,
                      noResultText: "Aucun enregistrement trouvé",
                      placeholder: "Rechercher par secteur"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "secteur",
                  class: "text-danger"
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h2", _hoisted_17, [
              _cache[12] || (_cache[12] = _createElementVNode("button", {
                class: "accordion-button collapsed",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#statisticsCollapse",
                "aria-expanded": "false",
                "aria-controls": "statisticsCollapse"
              }, [
                _createElementVNode("i", { class: "flaticon-chart me-2" }),
                _createTextVNode(" Statistiques des usagers ")
              ], -1)),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.exportStatisticsAsSVG && _ctx.exportStatisticsAsSVG(...args))),
                class: "btn btn-sm btn-outline-primary ms-2",
                title: "Exporter les statistiques en SVG"
              }, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("i", { class: "flaticon-download me-1" }, null, -1),
                _createTextVNode(" Export SVG ", -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"row\" data-v-054bc900><div class=\"col-md-6 mb-4\" data-v-054bc900><div class=\"card\" data-v-054bc900><div class=\"card-header\" data-v-054bc900><h5 class=\"card-title mb-0\" data-v-054bc900>État général des usagers</h5></div><div class=\"card-body\" data-v-054bc900><canvas id=\"etatGeneralChart\" width=\"400\" height=\"200\" data-v-054bc900></canvas></div></div></div><div class=\"col-md-6 mb-4\" data-v-054bc900><div class=\"card\" data-v-054bc900><div class=\"card-header\" data-v-054bc900><h5 class=\"card-title mb-0\" data-v-054bc900>Répartition par places</h5></div><div class=\"card-body\" data-v-054bc900><canvas id=\"placesChart\" width=\"400\" height=\"200\" data-v-054bc900></canvas></div></div></div><div class=\"col-md-6 mb-4\" data-v-054bc900><div class=\"card\" data-v-054bc900><div class=\"card-header\" data-v-054bc900><h5 class=\"card-title mb-0\" data-v-054bc900>Documents (NPI/IFU)</h5></div><div class=\"card-body\" data-v-054bc900><canvas id=\"documentsChart\" width=\"400\" height=\"200\" data-v-054bc900></canvas></div></div></div><div class=\"col-md-6 mb-4\" data-v-054bc900><div class=\"card\" data-v-054bc900><div class=\"card-header\" data-v-054bc900><h5 class=\"card-title mb-0\" data-v-054bc900>Informations personnelles</h5></div><div class=\"card-body\" data-v-054bc900><canvas id=\"infosPersonnellesChart\" width=\"400\" height=\"200\" data-v-054bc900></canvas></div></div></div></div>", 1)),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "card-header" }, [
                        _createElementVNode("h5", { class: "card-title mb-0" }, "Résumé statistique")
                      ], -1)),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("h4", _hoisted_27, _toDisplayString(_ctx.pointTotaux?.totalUsagersAJour || 0), 1),
                              _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-muted mb-0 small" }, "À jour", -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.pointTotaux?.totalUsagersNonAJour || 0), 1),
                            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-muted mb-0 small" }, "Non à jour", -1))
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("h4", _hoisted_31, _toDisplayString(_ctx.pointTotaux?.totalUsagersAvecImage || 0), 1),
                            _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-muted mb-0 small" }, "Avec image", -1))
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("h4", _hoisted_33, _toDisplayString(_ctx.pointTotaux?.totalUsagersAvecNPI || 0), 1),
                            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-muted mb-0 small" }, "Avec NPI", -1))
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("h4", _hoisted_35, _toDisplayString(_ctx.pointTotaux?.totalUsagersAvecIFU || 0), 1),
                            _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-muted mb-0 small" }, "Avec IFU", -1))
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("h4", _hoisted_37, _toDisplayString(_ctx.totalElements || 0), 1),
                            _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-muted mb-0 small" }, "Total", -1))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _cache[27] || (_cache[27] = _createElementVNode("hr", null, null, -1)),
        (_ctx.isLoadingTable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [...(_cache[21] || (_cache[21] = [
              _createElementVNode("div", {
                class: "spinner-border text-primary",
                role: "status",
                style: {"width":"3rem","height":"3rem"}
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
              ], -1),
              _createElementVNode("p", { class: "mt-3 text-muted" }, "Chargement des données...", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("table", _hoisted_40, [
                _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " ### "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " # "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Nom complet "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " NPI "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " IFU "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Sexe "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Téléphone "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Catégorie "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Activité "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Détail "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, " Actions ")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usagers, (us, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          ((us.medias && us.medias.length > 0))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "d-flex align-items-center",
                                "data-bs-toggle": "modal",
                                onClick: ($event: any) => (_ctx.handleVoirImage(us.medias)),
                                "data-bs-target": "#voirImageModal",
                                style: {"cursor":"pointer","text-decoration":"none"}
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.getUrlApiForFiles('Usagers', us.medias[(us.medias.length - 1)].nomMedia),
                                  alt: "PhotoUsager",
                                  width: "50",
                                  height: "50",
                                  class: "rounded-circle border border-2 border-light shadow-sm user-image",
                                  style: {"object-fit":"cover"},
                                  onError: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                                }, null, 40, _hoisted_44)
                              ], 8, _hoisted_43))
                            : (_openBlock(), _createElementBlock("div", _hoisted_45, [...(_cache[22] || (_cache[22] = [
                                _createElementVNode("i", {
                                  class: "fas fa-user text-muted",
                                  style: {"font-size":"20px"}
                                }, null, -1)
                              ]))]))
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_46, _toDisplayString(us.matricule), 1),
                      _createElementVNode("td", _hoisted_47, _toDisplayString(us.full_name), 1),
                      _createElementVNode("td", _hoisted_48, _toDisplayString(us.npi), 1),
                      _createElementVNode("td", _hoisted_49, _toDisplayString(us.ifu), 1),
                      _createElementVNode("td", _hoisted_50, _toDisplayString(us.sexe), 1),
                      _createElementVNode("td", _hoisted_51, _toDisplayString(us.tel), 1),
                      _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.afficher20Caracteres(us.activite)), 1),
                      _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.afficher20Caracteres(us.new_activite)), 1),
                      _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.afficher20Caracteres(us.nouveau_activite)), 1),
                      _createElementVNode("td", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _cache[25] || (_cache[25] = _createElementVNode("span", {
                            class: "badge text-white bg-secondary fs-15 dropdown-toggle",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createTextVNode(" Actions "),
                            _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_57, [
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, {
                                to: `detail-usager/${us.matricule}`,
                                type: "button",
                                class: "dropdown-item d-flex align-items-center"
                              }, {
                                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                  _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Détails ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                onClick: ($event: any) => (_ctx.getApercu(us)),
                                type: "button",
                                class: "dropdown-item d-flex align-items-center"
                              }, [...(_cache[24] || (_cache[24] = [
                                _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Apercu du statut ", -1)
                              ]))], 8, _hoisted_58)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createVNode(_component_PaginationComponent, {
                  page: _ctx.page,
                  totalPages: _ctx.totalPages,
                  totalElements: _ctx.totalElements,
                  limit: _ctx.limit,
                  onPaginate: _ctx.handlePaginate
                }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
              ])
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", {
              class: "modal-title",
              id: "imageModalLabel"
            }, "Aperçu de l'image"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("img", {
              src: _ctx.currentImageUrl,
              alt: "Image",
              class: "img-fluid"
            }, null, 8, _hoisted_64)
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_65, [
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "modal-header bg-primary text-white" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, [
              _createElementVNode("i", { class: "fas fa-image me-2" }),
              _createTextVNode(" Photo de l'usager ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close btn-close-white",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_68, [
            (_ctx.currentImageUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                  _createElementVNode("img", {
                    src: _ctx.currentImageUrl,
                    alt: "PhotoUsager",
                    class: "img-fluid rounded shadow-lg",
                    style: {"max-height":"500px","max-width":"100%","object-fit":"contain"},
                    onError: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleModalImageError && _ctx.handleModalImageError(...args)))
                  }, null, 40, _hoisted_70),
                  _cache[29] || (_cache[29] = _createElementVNode("div", {
                    class: "image-error text-center text-muted",
                    style: {"display":"none"}
                  }, [
                    _createElementVNode("i", {
                      class: "fas fa-exclamation-triangle",
                      style: {"font-size":"4rem"}
                    }),
                    _createElementVNode("p", { class: "mt-3" }, "Erreur lors du chargement de l'image")
                  ], -1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_71, [...(_cache[30] || (_cache[30] = [
                  _createElementVNode("i", {
                    class: "fas fa-image",
                    style: {"font-size":"4rem"}
                  }, null, -1),
                  _createElementVNode("p", { class: "mt-3" }, "Aucune image disponible", -1)
                ]))]))
          ]),
          _createElementVNode("div", _hoisted_72, [
            _cache[32] || (_cache[32] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              "data-bs-dismiss": "modal"
            }, [
              _createElementVNode("i", { class: "fas fa-times me-2" }),
              _createTextVNode(" Fermer ")
            ], -1)),
            (_ctx.currentImageUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.currentImageUrl,
                  target: "_blank",
                  class: "btn btn-primary"
                }, [...(_cache[31] || (_cache[31] = [
                  _createElementVNode("i", { class: "fas fa-external-link-alt me-2" }, null, -1),
                  _createTextVNode(" Ouvrir dans un nouvel onglet ", -1)
                ]))], 8, _hoisted_73))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 512)
  ], 64))
}